import {SelectProps} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";
import {FormItemProps} from "./FormItem";
import {SelectInput} from "./SelectInput";
import {useSelector} from "react-redux";
import {currentProjectSelectors} from "@features/currentProject";

const noeObjectsEndpoints = [
  "categories",
  "places",
  "stewards",
  "activities",
  "teams",
  "sessions",
] as const;
export type NOEEndpoint = (typeof noeObjectsEndpoints)[number];

export const noeObjectsEndpointsExtended = [...noeObjectsEndpoints, "registrations"] as const;
export type NOEEndpointExtended = (typeof noeObjectsEndpointsExtended)[number];

export const useNOEObjectsWithLabels = ({
  extended = false,
  showUnavailable = false,
}: {
  extended?: boolean;
  showUnavailable?: boolean;
}) => {
  const {t} = useTranslation();
  const {usePlaces, useTeams} = useSelector((s) => {
    const {usePlaces, useTeams} = currentProjectSelectors.selectProject(s);
    return {usePlaces, useTeams};
  });

  return (extended ? noeObjectsEndpointsExtended : noeObjectsEndpoints)
    .filter(
      (endpoint) =>
        showUnavailable || // Skip filtering if showUnavailable
        !((!usePlaces && endpoint === "places") || (!useTeams && endpoint === "teams"))
    )
    .map((endpoint) => ({
      label: t(`${endpoint}:label_other`),
      value: endpoint,
    }));
};

export const NOEObjectSelectInput = ({
  extended,
  ...props
}: Omit<FormItemProps<SelectProps>, "options"> & {
  extended?: boolean;
}) => {
  const options = useNOEObjectsWithLabels({extended});
  return <SelectInput options={options} allowClear {...props} />;
};
